import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20cityscape%20at%20golden%20hour%2C%20warm%20sunlight%2C%20urban%20skyline%20with%20traditional%20and%20contemporary%20architecture%2C%20soft%20atmospheric%20haze%2C%20elegant%20city%20panorama%2C%20professional%20editorial%20photography%2C%20rich%20golden%20amber%20tones%2C%20clean%20composition&width=1920&height=1080&seq=hero-bg-fenglou&orientation=landscape"
          alt="凤楼城市风光"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h1
          className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          凤楼信息 · 最新资讯与信息服务平台
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          为您提供最全面、最及时的凤楼信息服务，涵盖本地生活、商务资讯、休闲娱乐等多维度内容，助您快速获取所需信息，省时高效，一站直达。
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3">
          {categories.slice(0, 4).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="px-5 py-2.5 bg-white/15 backdrop-blur-sm border border-white/25 text-white rounded-full text-sm hover:bg-white/25 transition-all duration-200 cursor-pointer no-underline whitespace-nowrap hover:scale-105"
            >
              <i className={`${cat.icon} mr-1.5`}></i>
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center">
          <div className="flex items-center gap-6 text-white/60 text-sm">
            <span className="whitespace-nowrap flex items-center gap-1.5">
              <i className="ri-article-line"></i> 每日更新
            </span>
            <span className="whitespace-nowrap flex items-center gap-1.5">
              <i className="ri-check-double-line"></i> 信息权威
            </span>
            <span className="whitespace-nowrap flex items-center gap-1.5">
              <i className="ri-shield-check-line"></i> 内容可靠
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}